// @flow
import styled from "styled-components"

export const LogoWrap = styled.div`
  margin-right: 4rem;
`

export const RightWrap = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
`



// WEBPACK FOOTER //
// ./src/pages/_Page/MainNav/LoggedInNav/DesktopLoggedInNav/styled.js